<template>
    <div>
        <v-container>
            <v-row>
                <v-col cols="3">
                    <!-- <span class="overline">RECORDS FOR</span>
                    <h2 class="display-1">21st Jan, 2024 </h2> -->
                    <v-date-picker width="100%" color="primary" v-model="picker"></v-date-picker>                    
                </v-col>
                <v-col cols="9">
                    <RecordsTable />
                    <!-- <v-row no-gutters>
                        <v-col cols="6">
                            <v-card v-for="i in 6" :key="`test-${i}`">
                                <v-img>
                                    Hello
                                </v-img>
                                <v-card-title>
                                    // Here there will be image and brief of what actions was taken
                                </v-card-title>
                            </v-card>
                        </v-col>
                    </v-row> -->
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import RecordsTable from '../components/RecordsTable.vue';

export default {
    data: () => ({
        picker: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    }),
    components: {
        RecordsTable
    }
}

</script>